<template>
  <b-modal
    ref="modal"
    id="modal-inventario-produto-item"
    hide-header
    hide-footer
    body-class="p-0 overflow-hidden"
    content-class="border-0 shadow-lg"
    centered
    size="lg"
    @shown="onModalShown"
  >
    <b-overlay :show="processando" rounded="sm" opacity="0.8">
      <template #overlay>
        <div class="text-center">
          <b-spinner variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
          <p class="mt-2 mb-0 font-weight-bold">Salvando lançamento do inventário...</p>
        </div>
      </template>

      <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #20a8d8 0%, #1783ae 100%) !important;">
        <div class="header-icon-wrapper mr-3 bg-white-10">
          <i class="fa fa-balance-scale text-white"></i>
        </div>
        <div>
          <h5 class="mb-0 font-weight-bold text-white">Lançamento do Inventário</h5>
          <small class="text-white opacity-75">Informe peso e peças do produto contado</small>
        </div>
        <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="fechar()">
          <i class="fa fa-times fa-lg"></i>
        </b-button>
      </div>

      <div class="p-4 bg-white">
        <div class="modal-info-bar mb-4 bg-light border shadow-sm p-3 rounded">
          <b-row align-v="center">
            <b-col md="6">
              <small class="modal-label-premium">Produto</small>
              <h5 class="mb-0 font-weight-bold text-dark">{{ item.NOME_PRODUTO }}</h5>
              <small class="text-muted font-weight-bold">Código {{ item.PRODUTO_ID }}</small>
            </b-col>
            <b-col md="3" class="border-left">
              <small class="modal-label-premium">Centro</small>
              <h5 class="mb-0 font-weight-bold text-primary">{{ item.CENTRO_ESTOQUE_ID }}</h5>
              <small class="text-muted font-weight-bold">{{ item.NOME_CENTRO_ESTOQUE }}</small>
            </b-col>
            <b-col md="3" class="border-left text-right">
              <small class="modal-label-premium">Sequência</small>
              <h5 class="mb-0 font-weight-bold text-success">{{ item.SEQUENCIA }}</h5>
            </b-col>
          </b-row>
        </div>

        <div class="modal-section-title mb-3">
          <i class="fa fa-edit mr-2 text-primary"></i> Informações do Lançamento
        </div>

        <b-row>
          <b-col md="6">
            <b-form-group label="Peso (SALDO_FI)" label-class="modal-label-premium">
              <vue-autonumeric
                :key="`saldo-fi-${item.SEQUENCIA || 'novo'}`"
                ref="saldoFi"
                v-model="formulario.saldoFi"
                :options="formatoPeso"
                class="form-control text-right rounded-pill shadow-xs"
              ></vue-autonumeric>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Peças (SALDOFI_PECAS)" label-class="modal-label-premium">
              <vue-autonumeric
                :key="`saldo-pecas-${item.SEQUENCIA || 'novo'}`"
                v-model="formulario.saldoFiPecas"
                :options="formatoPecas"
                class="form-control text-right rounded-pill shadow-xs"
              ></vue-autonumeric>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="6">
            <div class="p-3 bg-light rounded border shadow-xs h-100">
              <small class="modal-label-premium">Estoque Atual</small>
              <div class="d-flex justify-content-between text-dark font-weight-bold mt-2">
                <span>Peso</span>
                <span>{{ formatarNumero(item.QUANT_ESTOQUE_ATUAL, 3) }}</span>
              </div>
              <div class="d-flex justify-content-between text-dark font-weight-bold mt-2">
                <span>Peças</span>
                <span>{{ formatarNumero(item.PECAS_ESTOQUE_ATUAL, 0) }}</span>
              </div>
            </div>
          </b-col>
          <b-col md="6">
            <div class="p-3 bg-light rounded border shadow-xs h-100">
              <small class="modal-label-premium">Último Lançamento</small>
              <div class="d-flex justify-content-between text-dark font-weight-bold mt-2">
                <span>Peso</span>
                <span>{{ formatarNumero(item.SALDO_FI, 3) }}</span>
              </div>
              <div class="d-flex justify-content-between text-dark font-weight-bold mt-2">
                <span>Peças</span>
                <span>{{ formatarNumero(item.SALDOFI_PECAS, 0) }}</span>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>

      <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-between">
        <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="fechar()">
          CANCELAR
        </b-button>
        <b-button variant="success" pill class="px-5 font-weight-bold shadow-sm" @click="salvar()">
          <i class="fa fa-check-circle mr-1"></i> SALVAR LANÇAMENTO
        </b-button>
      </div>
    </b-overlay>
  </b-modal>
</template>

<script>
import VueAutonumeric from 'vue-autonumeric'
import Tools from '@/tools/tools.js'

export default {
  name: 'InventarioProdutosItemModal',
  components: {
    VueAutonumeric
  },

  data() {
    return {
      processando: false,
      item: {
        SEQUENCIA: null,
        PRODUTO_ID: null,
        NOME_PRODUTO: null,
        CENTRO_ESTOQUE_ID: null,
        NOME_CENTRO_ESTOQUE: null,
        SALDO_FI: 0,
        SALDOFI_PECAS: 0,
        QUANT_ESTOQUE_ATUAL: 0,
        PECAS_ESTOQUE_ATUAL: 0
      },
      formulario: {
        saldoFi: 0,
        saldoFiPecas: 0
      },
      formatoPeso: {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalPlaces: 3,
        decimalPlacesShownOnBlur: 3,
        decimalPlacesShownOnFocus: 3,
        minimumValue: '0',
        modifyValueOnWheel: false,
        emptyInputBehavior: 'zero'
      },
      formatoPecas: {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalPlaces: 0,
        decimalPlacesShownOnBlur: 0,
        decimalPlacesShownOnFocus: 0,
        minimumValue: '0',
        modifyValueOnWheel: false,
        emptyInputBehavior: 'zero'
      }
    }
  },

  methods: {
    abrir(item) {
      this.item = { ...item }
      this.formulario = {
        saldoFi: Number(item.SALDO_FI || 0),
        saldoFiPecas: Number(item.SALDOFI_PECAS || 0)
      }

      this.$nextTick(() => {
        this.$bvModal.show('modal-inventario-produto-item')
      })
    },

    fechar() {
      this.$bvModal.hide('modal-inventario-produto-item')
    },

    onModalShown() {
      this.$nextTick(() => {
        const input = this.$refs.saldoFi?.$el?.querySelector('input')
        if (input && input.focus) {
          input.focus()
        }
      })
    },

    formatarNumero(valor, casas = 0) {
      return Number(valor || 0).toLocaleString('pt-BR', {
        minimumFractionDigits: casas,
        maximumFractionDigits: casas
      })
    },

    async salvar() {
      if (!this.item.SEQUENCIA) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Item do inventário não informado.')
        return
      }

      this.processando = true

      try {
        await this.$http.post('/api/protected/estoqueInventario/editarItem', {
          sequencia: this.item.SEQUENCIA,
          saldoFi: Number(this.formulario.saldoFi || 0),
          saldoFiPecas: Number(this.formulario.saldoFiPecas || 0)
        })

        Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Lançamento do inventário salvo com sucesso!')
        this.$emit('salvou')
        this.fechar()
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', err.response?.data || err.message)
      } finally {
        this.processando = false
      }
    }
  }
}
</script>

<style scoped>
.modal-header-premium {
  border-bottom: none;
}

.header-icon-wrapper {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 1.5rem;
}

.bg-white-10 {
  background-color: rgba(255, 255, 255, 0.15) !important;
}

.modal-section-title {
  font-size: 0.9rem;
  font-weight: 700;
  color: #2d3748;
  border-bottom: 2px solid #edf2f7;
  padding-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.modal-label-premium {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6c757d;
  margin-bottom: 0.4rem;
  display: block;
}

.shadow-xs {
  box-shadow: 0 2px 4px rgba(0,0,0,0.05) !important;
}

.btn-soft-danger {
  background-color: rgba(248, 108, 107, 0.1);
  color: #f86c6b;
  border: none;
}

.btn-soft-danger:hover {
  background-color: #f86c6b;
  color: white;
}

.opacity-75 {
  opacity: 0.75;
}
</style>


// WEBPACK FOOTER //
// src/views/estoque/inventario/InventarioProdutosItemModal.vue